import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,findArrayObject,isFunction } from '../../../../utils/utils';
import { Box } from '@material-ui/core';
import { JourneyTripBilty,JourneyTripPOD } from '../../../../components/icons';
import { Button } from '@material-ui/core';
import { loadElr,getElrInfo } from '../../../../store/actions/tripActionCreator';
import BiltyHomeSteps from '../../JourneyBilty/BiltyHomeSteps';
import BiltyFlow from '../../JourneyBilty/BiltyFlow/BiltyFlow';
import BiltyPopUp from '../../../components/Dialog/BiltyPopUp';
import ConsigneeConsignorSelect from '../../../components/BiltyDialogs/ConsigneeConsignorSelect';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:16,
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    borderRadius: 8,
    border: 'solid 1px #ddd',
    boxShadow:'none',
    justifyContent:'space-between'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  label:{
    color:'#0b1323',
    fontSize:18,
    fontWeight:600,
    marginLeft:16
  },
  value:{
    fontWeight:600,
    color:'#0b1323',
    fontSize:14,
    textAlign:'center'
  },
  viewLR:{
    padding:'9px 29px',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    color: '#00875a',
    fontWeight: 600,
    borderRadius: 4,
    fontSize:14,
    border: 'solid 1px #00875a',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  createLRButton:{
    padding:'9px 24px',
    backgroundColor: '#00875a',
    textTransform: 'capitalize',
    color: '#fff',
    fontWeight: 600,
    borderRadius: 4,
    fontSize:14,
    //border: 'solid 1px #00875a',
    '&:hover': {
      backgroundColor: '#00875a'
    }
  }
}));
const JourneyTripCreateViewLRCard = (props) => {
  const {selectedTrip,journey,updateJourney,dispatchLoadElr,dispatchGetElrInfo} = props;
  const classes = useStyles();
  let history = useHistory();
  let selectedLr = findArrayObject('tripId',selectedTrip.id,journey.elrs);
  const allTrue = selectedLr && selectedLr.status? Object.keys(selectedLr.status).every(k => selectedLr.status[k]):false;
  const [biltyOpen, setBiltyOpen] = useState(false);
  const [biltyStepsOpen, setBiltyStepsOpen] = useState(false);
  const [biltyFlowOpen, setBiltyFlowOpen] = useState(false);
  const [pdfPreview, setPdfPreview] = useState(false);
  const [biltyTimeline, setBiltyTimeline] = useState(false);
  const [biltyPopUp, setBiltyPopUp] = useState(false);
  const handleBiltyStepsClose = () => {
    setBiltyStepsOpen(false);
  }

  const handleCreateBilty = () => {


    setBiltyStepsOpen(false);

    if (selectedLr && selectedLr.status) {
      const checkAllTrue = Object.keys(selectedLr.status).every(k => selectedLr.status[k]);
      const checkAllFalse = Object.keys(selectedLr.status).every(k => !selectedLr.status[k]);
      const checkAnyFalse = Object.keys(selectedLr.status).some(k => !selectedLr.status[k]);

      if (!checkAllTrue) {
        setPdfPreview(false)
      }

      setTimeout(() => {
        setBiltyFlowOpen(true);
      }, 110)

      if (checkAllFalse) {
        setBiltyTimeline(false);
      } else if (checkAnyFalse) {
        setBiltyTimeline(true);
      }

    } else {
      setTimeout(() => {
        setBiltyFlowOpen(true);
      }, 110)
    }

  }
  const handleBiltyFlowClose = () => {
    setBiltyFlowOpen(false);
  }

  const handleBiltyPopUpClose = () => {
    setBiltyPopUp(false);
  }
  const goToBilty = () => {
    setBiltyPopUp(false);
  }
  const handleBilty = () =>{
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    let checkAllTrue = false;
      if (selectedLr && selectedLr.status) {
        checkAllTrue = Object.keys(selectedLr.status).every(k => selectedLr.status[k]);
      }
      dispatchLoadElr(
        selectedTrip.id,
        (res) => {
          if (res && res.status && res.status.code == 200) {
            if (selectedLr && selectedLr.id) {
              dispatchGetElrInfo(selectedLr.id,
                (data) => {
                  if (data && data.status && data.status.code == 200) {
                    if (checkAllTrue) {
                      setPdfPreview(true);
                      setBiltyFlowOpen(true);
                    } else {
                      setBiltyStepsOpen(true);
                    }
                  }
                },
                () => {
                }
              )
            } else {
              setBiltyStepsOpen(true);
            }
          }
        },
        () => {
        }
      )
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box display={'flex'} alignItems={'center'}>
          <JourneyTripBilty />
          <Typography className={classes.label}>Online Bilty/LR</Typography>
        </Box>
        {allTrue && selectedLr && selectedLr.id?
        <Button variant='outlined'  onClick={handleBilty} className={classes.viewLR} >View LR</Button>
        :<Button variant='contained' onClick={handleBilty} className={classes.createLRButton} >Create LR</Button>
      }
      </Paper>
      {biltyStepsOpen && <BiltyHomeSteps open={biltyStepsOpen} journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} onClose={handleBiltyStepsClose} onCreateBilty={handleCreateBilty} />}
      {biltyFlowOpen && <BiltyFlow open={biltyFlowOpen} journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} onClose={handleBiltyFlowClose} biltyTimeLineValue={biltyTimeline} pdfPreviewValue={pdfPreview} />}
      {biltyPopUp && <BiltyPopUp open={biltyPopUp} journey={journey} updateJourney={updateJourney} onClose={handleBiltyPopUpClose} onBilty={goToBilty} />}
    </>
  );
}
const JourneyTripCreateViewLRCardWithRouter = withRouter(JourneyTripCreateViewLRCard);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLoadElr: (tripId, onSuccess, onFailure) => {
    dispatch(loadElr(tripId, onSuccess, onFailure))
  },
  dispatchGetElrInfo: (elrId, onSuccess, onError) => {
    dispatch(getElrInfo(elrId, onSuccess, onError))
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyTripCreateViewLRCardWithRouter);